import React, {PropTypes} from 'react';
import {Field} from 'redux-form';
import StandardField from 'shared/StandardField.jsx';
import ManagerItem from './ManagerItem.jsx';

const ManagersPanel = ({
  managers,
  userEmail,
  onAddManagerClick,
  onSaveClick,
  onEditClick,
  onCancelClick,
  onRemoveClick
}) => (
  <div className="panel panel-default">
    <div className="panel-heading">
      <h4 className="panel-title">
        <span>
          <button type="button"
            className="btn btn-link pull-right"
            onClick={onAddManagerClick}>
            <i className="fa fa-plus"/> {'Add Manager'}
          </button>
          <Field
            name="managers"
            type="hidden"
            component={StandardField}
            style={{"float":"left"}}
            label="Managers"
            tooltip="A person who can create tournament, update tournament set up, and update capacity levels"
            tooltipPosition="top"
          />
        </span>
      </h4>
    </div>
    <div className="panel-body">
      <div className="list-group">
        {managers.map((item, index) => (
          <ManagerItem key={index}
            {...item}
            canEditPrimary={item.email != null && item.email.toLowerCase() == userEmail.toLowerCase()}
            onSaveClick={onSaveClick}
            onEditClick={onEditClick}
            onCancelClick={onCancelClick}
            onRemoveClick={onRemoveClick}/>
        ))}
      </div>
    </div>
  </div>
);

ManagersPanel.propTypes = {
  managers: PropTypes.arrayOf(PropTypes.object),
  userEmail: PropTypes.string,
  onAddManagerClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onRemoveClick: PropTypes.func
};

ManagersPanel.defaultProps = {
  managers: []
};

export default ManagersPanel;


// WEBPACK FOOTER //
// ./src/features/tournament/permissions/ManagersPanel.jsx